/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { bitSet, entity, enumeration } from '@gh/core-data';

import { SYSTEM_ROLES_BIT_SIZE } from '../profiles';
import { OfficeUserListItemDto, UserListFilterDto, UserListItemDto } from './user-list-item.dto';
import { UserStatus } from './user-status.enum';

export const UserListItemMapper = entity<UserListItemDto>({
  statusValue: enumeration(UserStatus),
});
export const OfficeUserListItemMapper = entity<OfficeUserListItemDto>({
                                                            statusValue: enumeration(UserStatus),
                                                          });
export const UserListFilterMapper = entity<UserListFilterDto>({ systemRoles: bitSet(SYSTEM_ROLES_BIT_SIZE) });
